'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mediaEvents = require('../ads/media/mediaEvents');

var _mediaEvents2 = _interopRequireDefault(_mediaEvents);

var _Events = require('../ads/media/Events');

var _Events2 = _interopRequireDefault(_Events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function info(data) {
  if (!data) {
    return;
  }
  _mediaEvents2.default.event(_Events2.default.Logging.info).emit(data);
}

function error(err) {
  if (!err) {
    return;
  }
  _mediaEvents2.default.event(_Events2.default.Logging.error).emit(err);
}

function debug(message) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!this.debugEnabled) {
    return;
  }
  // eslint-disable-next-line no-console
  console.warn('[mint] ' + message, context);
}

exports.default = {
  info: info,
  error: error,
  debug: debug
};